/** Existing sheet PC-column reader, shared with roster rendering. */
export function readPlayerCharacterField(caster: unknown, key: string): unknown {
    if (!caster || typeof caster !== 'object') return undefined;
    const pc = (caster as { player_characters?: Record<string, unknown> }).player_characters;
    if (pc === undefined || pc === null) return undefined;
    const value = pc[key];
    return Array.isArray(value) ? value[0] : value;
}
